<template>
  <v-card class="mb-2">
    <v-card-text>
      <div ref="theDiv" style="width: 100%">
        <LineChart
          v-if="maxW != null"
          :data="points"
          xProp="dt"
          yProp="count"
          :height="30"
          :width="maxW"
          :ttHeight="40"
          :ttWidth="160"
        >
          <template slot-scope="{ item, isLeft }">
            <div class="lineChartTooltip" :class="{ left: isLeft }">
              {{ item.dt | moment('DD/MMM/YYYY HH:mm:ss') }}
              <br>
              <b>{{ item.count }}</b> HBs, {{ kb(item.bytes)}} KB
            </div>
          </template>
        </LineChart>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { go } from '@/models'
import moment from 'moment'

export default {
  components: {
    LineChart: require('@/components/LineChart').default
  },
  data() {
    return {
      points: [],
      maxW: null
    }
  },
  mounted() {
    this.reload()
  },

  methods: {
    async reload() {
      let points = await go.get('slicer/stats', { periodMs: 10 * 60 * 1000 })
      points.forEach(p => (p.dt = moment(p.dt).toDate()))

      this.points = points
      this.maxW = this.$refs.theDiv.getBoundingClientRect().width
    },

    kb(x) {
      return Math.floor((x || 0) / 1024)
    }
  }
}
</script>

<style>
